module.exports = function getResource(label, vars = []) {
    let resources = {
        addTheseTitle: 'Add These for Under $15'
    };

    return resources[label];
};
